import React ,{useState ,useEffect}from 'react'
import MasonryLayout from './MasonryLayout';
import Spinner from './Spinner';
import { useParams } from 'react-router-dom';

import { client } from '../client';
import { feedQuery, searchQuery } from '../utils/data';




function Feed()
{
  const [pins, setPins] = useState();
  const [loading, setLoading] = useState(false)
  const { categoryId } = useParams();

  useEffect(() => {
    if (categoryId) 
    {
      setLoading(true);
      const query = searchQuery(categoryId);
      client.fetch(query).then((data) => 
      {

        setPins(data);
        setLoading(false);
      });


    } else 
    {
      client.fetch(feedQuery).then((data)=>{
        setPins(data)
        setLoading(false);
      })
      setLoading(true);



    }
  }, [categoryId]);



  if(loading) return<Spinner message ="NEBULA is adding new Ideas to your Feed"/>
  if(!pins?.length)
  {
    return(
      <div className="text-white align-center">
        <p className="text-white text-center">No PINS AVAILABLE</p> 
      </div>
    )
  } 
    
  
  return (
    <div>
      {pins && <MasonryLayout pins={pins}/>}
    </div>
  )
}

export default Feed